import React from 'react';
import { useTheme } from '../../context/ThemeContext';
import { triggerDiwaliFireworks } from './DiwaliFireworksCanvas';

const BULB_COLORS = [
  { color: '#f59e0b', glow: 'rgba(245, 158, 11, 0.85)', name: 'gold' },
  { color: '#ef4444', glow: 'rgba(239, 68, 68, 0.85)', name: 'red' },
  { color: '#10b981', glow: 'rgba(16, 185, 129, 0.85)', name: 'green' },
  { color: '#fbbf24', glow: 'rgba(251, 191, 36, 0.9)', name: 'yellow' },
  { color: '#a855f7', glow: 'rgba(168, 85, 247, 0.85)', name: 'purple' },
  { color: '#f97316', glow: 'rgba(249, 115, 22, 0.85)', name: 'orange' },
  { color: '#06b6d4', glow: 'rgba(6, 182, 212, 0.85)', name: 'cyan' },
];

export const DiwaliFairyLights: React.FC = () => {
  const { isDiwali } = useTheme();

  if (!isDiwali) return null;

  // 24 decorative hanging lights across the top
  const bulbs = Array.from({ length: 24 });

  return (
    <div
      className="ns-diwali-lights-container"
      aria-hidden="true"
      title="Diwali Festive Lights - Click to burst crackers! 🎆"
      onClick={() => triggerDiwaliFireworks({ count: 4 })}
    >
      <div className="ns-diwali-lights-wire" />
      <div className="ns-diwali-lights-list">
        {bulbs.map((_, index) => {
          const config = BULB_COLORS[index % BULB_COLORS.length];
          const delay = (index % 4) * 0.45;
          const dropHeight = index % 2 === 0 ? 11 : 7;

          return (
            <div
              key={index}
              className={`ns-diwali-bulb-wrapper ns-diwali-bulb--${index % 4}`}
              style={{
                height: `${dropHeight + 14}px`,
                animationDelay: `${delay}s`,
              }}
            >
              <div className="ns-diwali-bulb-socket" />
              <div
                className="ns-diwali-bulb-glass"
                style={{
                  backgroundColor: config.color,
                  boxShadow: `0 0 8px 2px ${config.glow}, 0 0 16px 4px ${config.glow}`,
                }}
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default DiwaliFairyLights;

